module.exports = __webpack_public_path__ + "img/line_taw.81751150.png";